export default "__VITE_ASSET__29c1c3e4__"